import { apiGet, apiPost } from '../services/api';


export interface Customer {
  id: number;
  name: string;
  mobile_number: string;
}

export async function createOne(data: Partial<Omit<Customer, 'id' | 'created_at' | 'updated_at' | 'branch'>>) {
  return apiPost<Customer>('/api/customers', data);
}

export async function searchByMobileNumber(mobileNumber: string): Promise<Customer | null> {
  const response = await apiGet<{ data: Customer[] }>(`/api/customers?mobile_number=${encodeURIComponent(mobileNumber)}&per_page=1`);
  const customers = response.data || [];
  return customers.length > 0 ? customers[0] : null;
}
